// Saathi motion: a two-circle cursor trail (teal dot + amber ring, like the logo) and a logo
// that leans towards the pointer. Mouse/trackpad only; off when the user prefers reduced motion.
const fine = window.matchMedia("(pointer: fine)").matches;
const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function cursor() {
	const dot = document.createElement("div");
	const ring = document.createElement("div");
	dot.className = "sa-cursor-dot";
	ring.className = "sa-cursor-ring";
	document.body.append(ring, dot);

	let x = innerWidth / 2, y = innerHeight / 2, rx = x, ry = y, shown = false;
	addEventListener("mousemove", (e) => {
		x = e.clientX;
		y = e.clientY;
		if (!shown) {
			rx = x; ry = y; shown = true;
			document.body.classList.add("sa-cursor-on");
		}
		const hot = e.target.closest && e.target.closest("a, button, .btn, [role=button], input, select, textarea, .sa-tile, .es-button, .widget");
		ring.classList.toggle("is-hot", !!hot);
	}, { passive: true });
	document.addEventListener("mouseleave", () => document.body.classList.remove("sa-cursor-on") || (shown = false));
	addEventListener("mousedown", () => ring.classList.add("is-down"));
	addEventListener("mouseup", () => ring.classList.remove("is-down"));

	(function frame() {
		rx += (x - rx) * 0.18;
		ry += (y - ry) * 0.18;
		const lag = Math.min(Math.hypot(x - rx, y - ry), 40);
		dot.style.transform = `translate3d(${x}px, ${y}px, 0)`;
		ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) scale(${1 + lag / 120})`;
		requestAnimationFrame(frame);
	})();
}

function leaningLogo() {
	addEventListener("mousemove", (e) => {
		for (const img of document.querySelectorAll(".sa-lb-logo, .sa-hero-logo")) {
			const r = img.getBoundingClientRect();
			const dx = (e.clientX - (r.left + r.width / 2)) / innerWidth;
			const dy = (e.clientY - (r.top + r.height / 2)) / innerHeight;
			img.style.transform = `perspective(400px) rotateY(${dx * 18}deg) rotateX(${-dy * 18}deg) translate(${dx * 6}px, ${dy * 6}px)`;
		}
	}, { passive: true });
}

if (fine && !calm) {
	const start = () => { cursor(); leaningLogo(); };
	document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start();
}
